const emailUrl = (provider, url) => {
  return `mailto:?subject=${'Your friend wants to share this doctor with you.'}&body=I thought you would be interested in this doctor at OhioHealth. ${provider.title} ${url}`
}

export default emailUrl
